import { render, staticRenderFns } from "./LeftManu.vue?vue&type=template&id=23a8600f&scoped=true"
import script from "./LeftManu.vue?vue&type=script&lang=js"
export * from "./LeftManu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a8600f",
  null
  
)

export default component.exports